import { find, includes, isEmpty } from 'lodash';
import type { RootState } from '@client/store';
import type { GenericList } from '@sda/helpers/helpers.types';

export const DEFAULT_RESPONSE = null;

/**
 * Passes an ID to the selector to fetch an item by ID
 * @param  {any} state
 * @param  {string|number} itemId
 * @return {string}
 */
export const selectItemById = (_: RootState, itemId: string) => itemId;

/**
 * Passes an ID to the selector to fetch an item by ID
 * @param  {any} state
 * @param  {string|number} itemId
 * @return {string}
 */
export const selectItemByOptionalId = (_: RootState, itemId?: string) => itemId;

/**
 * Passes a callback function to user as a selector
 * @param  {any} state
 * @param  {function} callback function to use as a selector
 * @return {callback}
 */
export const selectItemByCallback = (_: RootState, callback) => callback;

export const selectItemByDictionary = (_: RootState, dictionary: unknown): unknown => dictionary;

export const selectItemByOptionalDictionary = (_: RootState, dictionary?: unknown): unknown => dictionary;

export const selectItemByArray = (_: RootState, arr: any[]) => arr;

export const defaultItemSelectorById = <T>(items: GenericList<T>, itemId: string): T => (
  items && itemId && items[itemId] ? items[itemId] : DEFAULT_RESPONSE
);

export const defaultItemSelectorByVanityUrlLowercase = <T extends { vanityUrlLowercase: string, vanityUrlCache: string[] }>(
  items: GenericList<T>,
  vanityUrl: string,
): T => {
  if (isEmpty(items)) {
    return DEFAULT_RESPONSE;
  }

  return find(items, (item) => item.vanityUrlLowercase === vanityUrl.toLowerCase())
  || find(items, (item) => includes(item.vanityUrlCache, vanityUrl.toLowerCase()));
};

export const createSelectorFactory = <T>(selector: T) => (): T => selector;
